import { Controller } from "@hotwired/stimulus"

// A lightbox for a set of images (the Key Data screenshots on the desk). A
// thumbnail link opens the native <dialog> at its image. The arrow keys, the
// Previous and Next cards, or a click on the backdrop move through or close
// it; the set wraps at both ends. Each item brings its own title, amount and
// detail line for the text under the image.
//
// Keys stop at the dialog, because the drawer around the desk listens on the
// window: its Escape would close the whole drawer, and its Tab trap would
// reach for controls the modal has made inert. Without JavaScript the
// thumbnail link still opens the image in a new tab.
export default class extends Controller {
  static values = { items: Array }
  static targets = [
    "dialog", "image", "title", "counter", "amount", "details",
    "previous", "previousImage", "previousLabel", "next", "nextImage", "nextLabel"
  ]

  open(event) {
    event.preventDefault()
    this.show(event.params.index)
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  showPrevious() {
    this.show(this.index - 1)
  }

  showNext() {
    this.show(this.index + 1)
  }

  key(event) {
    event.stopPropagation()
    if (event.key === "ArrowRight") {
      event.preventDefault()
      this.showNext()
    } else if (event.key === "ArrowLeft") {
      event.preventDefault()
      this.showPrevious()
    } else if (event.key === "Escape") {
      event.preventDefault()
      this.close()
    }
  }

  // The dialog element itself is hit only outside its panel, on the backdrop.
  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  show(index) {
    const items = this.itemsValue
    this.index = this.wrap(index)
    const item = items[this.index]

    this.imageTarget.src = item.src
    this.imageTarget.alt = item.alt
    this.titleTarget.textContent = item.title
    this.counterTarget.textContent = `${this.index + 1} of ${items.length}`
    this.amountTarget.textContent = item.amount || ""
    this.amountTarget.hidden = !item.amount
    this.detailsTarget.textContent = item.details || ""
    this.detailsTarget.hidden = !item.details

    const single = items.length < 2
    this.previousTarget.hidden = single
    this.nextTarget.hidden = single
    if (single) return

    this.fillCard(this.previousImageTarget, this.previousLabelTarget, items[this.wrap(this.index - 1)])
    this.fillCard(this.nextImageTarget, this.nextLabelTarget, items[this.wrap(this.index + 1)])
  }

  fillCard(image, label, item) {
    image.src = item.src
    label.textContent = item.title
  }

  wrap(index) {
    const count = this.itemsValue.length
    return ((index % count) + count) % count
  }
}
